/**
 *
 * PersonasReport
 *
 */

import { restClient } from "../../../Helpers/restClient";

export class PersonasReportService {
  static baseUrl = "/security/person";

  static async generateReport(residentialNo) {
    return await restClient.httpGet(`${this.baseUrl}/generate-persona-report`, {
      residentialNo,
    });
  }

  static async createOrUpdate(request) {
    return await restClient.httpPost(`${this.baseUrl}/`, request);
  }

  static async remove(id) {
    return await restClient.httpDelete(`${this.baseUrl}/`);
  }
}
